export const APP_TERMS = {
    error_title: "Error",
    zip_code_title: "Clinic ZIP code",
    zip_code_required_validation: "Please enter Clinic ZIP code",
    zip_code_invalid_validation: "Please enter a valid Clinic ZIP code",
    file_upload_invalid_validation: "Please attach a minimum of one report",
    file_upload_to_server_failed: "A few files were not uploaded correctly",
    case_service_invalid_validation: "Please add a minimum of one service",
    "date_1_format": "MM-dd-yyyy",
    generic_case: "Cases",
    generic_to: "To",
    generic_invoice: "Invoices",
    generic_draft: "Draft",
    generic_patients: "Patients",
    generic_details: "Details",
    generic_name: "Name",
    generic_first: "First",
    generic_last: "Last",
    generic_gender: "Gender",
    generic_gender_male: "Male",
    generic_gender_female: "Female",
    generic_gender_other: "Other",
    generic_submitted: "Submitted",
    generic_submitting: "Submitting",
    generic_completed: "Completed",
    generic_next: "Next",
    generic_appointement: "Appoinment",
    generic_study: "Study",
    generic_purpose: "Purpose",
    generic_date: "Date",
    generic_scan: "Scan",
    generic_office: "Office",
    generic_referring: "Referring",
    generic_doctor: "Doctor",
    generic_add: "Add",
    generic_edit: "Edit",
    generic_services: "Services",
    generic_upload: "Upload",
    generic_files: "Files",
    generic_documents: "Documents",
    generic_general: "General",
    generic_description: "Description",
    impaction_label: "Impaction",
    implant_label: "Implant",
    orthodontic_label: "Orthodontic",
    pathology_label: "Pathology",
    sinus_label: "Sinus",
    tmd_pain_label: "TMD/Pain",
    airway_label: "Airway",
    platform_id_label: "Platform ID",
    platform_id_placeholder: "Enter user's platform ID if available",
    created_case_list_title: "Created Cases",
    draft_case_list_title: "Draft Cases",
    submitted_case_list_title: "Submitted Cases",
    awaiting_approval_case_list_title: "Awaiting Approval",
    completed_case_list_title: "Completed Cases",
    add_case_title: "Add Case",
    region_interest_label: "Region Interest",
    cases_comment_label: "Cases Comments",
    date_of_birth_label: "Date Of Birth",
    download_failed: "Download Failed",
    case_result_summary_title: "Case Result Summary",
    generic_internal: "Internal",
    generic_comments: "Comments",
    generic_radiologist: "Radiologist",
    generic_admin: "Admin",
    generic_report: "Report",
    generic_template: "Template",
    process_case_title: "Process Case",
    generic_branch: "Branch",
    generic_clinic: "Clinic",
    generic_location: "Location",
    generic_location_plural: "Locations",
    checks_payable_to: "Checks Payable To",
    generic_due: "Due",
    app_title: "Voxel Readers",
    due_date_alert: "Within 30 Days"
}